"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.ROUND_STATUSES = void 0;

var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _QuizService = require("../QuizService");

var _QuizHelper = _interopRequireDefault(require("../QuizHelper"));

var _QuestionStatus = require("./QuestionStatus");

var ROUND_STATUSES = {
  OPEN: 'open',
  COMPLETED: 'completed',
  FAILED: 'failed'
};
exports.ROUND_STATUSES = ROUND_STATUSES;

var RoundObject = /*#__PURE__*/function () {
  function RoundObject(roundId, percentageCorrect, questionIds) {
    var _this = this;

    (0, _classCallCheck2["default"])(this, RoundObject);
    this.alreadyPlayed = false;
    this.addedToHighscoreList = false;
    this.roundId = roundId;
    this.status = ROUND_STATUSES.OPEN;
    this.nextQuestion = 0;
    this.questions = {};
    this.questionIds = questionIds;
    this.passed = false;
    this.currentOrder = null;
    this.points = 0;
    this.percentageCorrect = percentageCorrect;
    this.startedReadingEvaluation = null;
    this.pauseBegin = undefined;
    this.pauseTime = 0;
    this.viewedQuestions = [];
    (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var roundPlayed;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _QuizService.getRoundPlayed)(_this.roundId);

            case 2:
              roundPlayed = _context.sent;

              if (roundPlayed[0]) {
                _this.alreadyPlayed = roundPlayed[0].value.played;
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
    /* getRoundPlayed(this.roundId).then((roundPlayed) => {
      if (roundPlayed[0]) {
        this.alreadyPlayed = roundPlayed[0].value.played;
      }
    }); */
  }

  (0, _createClass2["default"])(RoundObject, [{
    key: "addQuestion",
    value: function addQuestion(id, questionStatus) {
      this.questions[id] = questionStatus;
    }
  }, {
    key: "getQuestions",
    value: function getQuestions() {
      var _this2 = this;

      if (this.currentOrder) {
        return this.currentOrder.map(function (index) {
          return _this2.questions[_this2.questionIds[index]];
        });
      }

      return this.questionIds.map(function (id) {
        return _this2.questions[id];
      });
    }
  }, {
    key: "getQuestion",
    value: function getQuestion(questionId) {
      return this.questions[this.questionIds[this.currentOrder[questionId]]];
    }
  }, {
    key: "getQuestionCount",
    value: function getQuestionCount() {
      return this.questionIds.length;
    }
  }, {
    key: "getRealQuestionNumber",
    value: function getRealQuestionNumber(questionNumber) {
      return this.currentOrder[questionNumber];
    }
  }, {
    key: "addViewedQuestion",
    value: function addViewedQuestion(questionNumber, questionId) {
      console.log("adding viewed question: ".concat(String(questionNumber), " / ").concat(questionId));
      this.viewedQuestions.push({
        displayPosition: questionNumber,
        id: questionId
      });
    }
  }, {
    key: "getViewedQuestions",
    value: function getViewedQuestions() {
      return this.viewedQuestions;
    }
  }, {
    key: "resetViewedQuestions",
    value: function resetViewedQuestions() {
      this.viewedQuestions = [];
    }
  }, {
    key: "resetRound",
    value: function resetRound() {
      console.log('reset round');
      (0, _values["default"])(this.questions).forEach(function (question) {
        question.resetQuestion();
      });
      this.setOrder();
    }
  }, {
    key: "shuffleOrder",
    value: function shuffleOrder() {
      this.currentOrder = _QuizHelper["default"].shuffleArray(this.currentOrder);
      (0, _values["default"])(this.questions).forEach(function (question) {
        question.shuffleAnswers();
      });
    }
  }, {
    key: "setOrder",
    value: function setOrder() {
      if (this.currentOrder === null) {
        this.currentOrder = [];

        for (var i = 0; i < this.getQuestionCount(); i++) {
          this.currentOrder.push(i);
        }
      }

      if (this.alreadyPlayed) {
        this.shuffleOrder();
      }
    }
  }, {
    key: "setStartReadingRoundEvaluation",
    value: function setStartReadingRoundEvaluation() {
      if (this.startedReadingEvaluation === null) {
        this.resetViewedQuestions();
        this.startedReadingEvaluation = new Date();
      }
    }
  }, {
    key: "setStopReadingRoundEvaluation",
    value: function setStopReadingRoundEvaluation() {
      if (this.startedReadingEvaluation === null) {
        this.timeToRead = 0;
      }

      var stoppedReadingEvaluation = new Date();
      this.timeToRead = (stoppedReadingEvaluation - this.startedReadingEvaluation) / 1000 - this.pauseTime;
      this.startedReadingEvaluation = null;
    }
  }, {
    key: "setPauseBegin",
    value: function setPauseBegin() {
      console.log('setting pause');
      this.pauseBegin = new Date();
    }
  }, {
    key: "setPauseEnd",
    value: function setPauseEnd() {
      this.pauseTime += (new Date() - this.pauseBegin) / 1000;
      console.log("pause Time:".concat(this.pauseTime));
    }
  }, {
    key: "update",
    value: function update() {
      var numberOfPassedQuestions = 0;
      var totalNumberOfQuestions = 0;
      var points = 0;
      (0, _values["default"])(this.questions).forEach(function (question) {
        totalNumberOfQuestions += 1;

        if (question.status === _QuestionStatus.QUESTION_STATUSES.CORRECT) {
          numberOfPassedQuestions += 1;
          points += question.reachablePoints;
        }
      });
      this.points = points;
      this.passed = numberOfPassedQuestions >= totalNumberOfQuestions * (this.percentageCorrect / 100);
    }
  }]);
  return RoundObject;
}();

exports["default"] = RoundObject;